export const is3rdPartyWorkflow = (item) => item?.metaData?.template?.workflow === "3rd_party";